<template>
  <footer class="pos-fnb-footer" v-on-clickaway="away">
    <div class="row">
      <!-- <div v-if="!FnBItemsModule" class="col-md-9 col-lg-8 col-xl-9">
        <div v-if="!FnBItemsModule" class="col-md-9 col-lg-8 col-xl-9">
          <div class="pos-fnb-menus" :class="FnbHiddenMenus ? 'rounded-top-0' : ''">
            <div class="row h-100">
              <div class="col-2 px-0">
                <button class="btn-pos-menu" @click="splitPaymentModal = !splitPaymentModal">
                  <SplitPayment v-bind:showModal="splitPaymentModal"></SplitPayment>
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.7263 5.89913L24.1014 0.274214C23.7358 -0.0914048 23.1414 -0.0914048 22.7758 0.274214L17.1509 5.89913C16.8827 6.16912 16.8021 6.57037 16.9465 6.92099C17.0909 7.27161 17.434 7.50035 17.8127 7.50035H20.6252V10.1066C20.6252 11.0609 20.1583 11.9384 19.3746 12.4578L15.949 14.7415C15.6284 14.9515 15.3134 15.1952 15.0003 15.4784C14.6871 15.1952 14.374 14.9534 14.0572 14.7452L10.6222 12.4559C9.84222 11.9384 9.37535 11.0609 9.37535 10.1066V7.50035H12.1878C12.5666 7.50035 12.9097 7.27161 13.054 6.92099C13.1984 6.57037 13.1178 6.16912 12.8515 5.89913L7.22663 0.274214C6.86102 -0.0914048 6.26665 -0.0914048 5.90103 0.274214L0.276119 5.89913C0.00799783 6.16912 -0.0726259 6.57037 0.0717469 6.92099C0.21612 7.27161 0.559239 7.50035 0.937983 7.50035H3.75044V10.1066C3.75044 12.9378 5.15479 15.5627 7.50601 17.1302L10.941 19.4195C11.7209 19.937 12.1878 20.8145 12.1878 21.7689V29.0625C12.1878 29.58 12.6078 30 13.1253 30H16.8752C17.3927 30 17.8127 29.58 17.8127 29.0625V21.7689C17.8127 20.8145 18.2796 19.937 19.0633 19.4177L22.4945 17.1302C24.8457 15.5627 26.2501 12.9378 26.2501 10.1066V7.50035H29.0625C29.4413 7.50035 29.7844 7.27161 29.9288 6.92099C30.0732 6.57037 29.9925 6.16912 29.7263 5.89913ZM25.3126 5.62538C24.7951 5.62538 24.3751 6.04537 24.3751 6.56287V10.1066C24.3751 12.3078 23.2839 14.3515 21.4539 15.5702L18.0265 17.8558C16.7177 18.7202 15.9377 20.1827 15.9377 21.7689V28.125H14.0628V21.7689C14.0628 20.1827 13.2828 18.7221 11.9778 17.8577L8.54661 15.5702C6.71664 14.3515 5.62541 12.3078 5.62541 10.1066V6.56287C5.62541 6.04537 5.20542 5.62538 4.68792 5.62538H3.20107L6.5629 2.26356L9.92472 5.62538H8.43787C7.92037 5.62538 7.50038 6.04537 7.50038 6.56287V10.1066C7.50038 11.6928 8.28037 13.1534 9.58535 14.0177L13.0222 16.309C13.4478 16.5883 13.8678 16.9558 14.3121 17.4358C14.6646 17.8202 15.3378 17.8202 15.6884 17.4358C16.1309 16.9558 16.5527 16.5883 16.9821 16.3052L20.4096 14.0196C21.7202 13.1553 22.5001 11.6928 22.5001 10.1066V6.56287C22.5001 6.04537 22.0802 5.62538 21.5627 5.62538H20.0758L23.4376 2.26356L26.7995 5.62538H25.3126V5.62538Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Split Payments</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>-->
      <!-- v-if="FnBItemsModule" -->
      <div class="col-md-9 col-lg-9 col-xl-9 col-sm-8">
        <div
          class="pos-fnb-menus"
          :class="FnbHiddenMenus ? 'rounded-top-0' : ''"
        >
          <div class="row h-100" style="flex-wrap:nowrap">
            <div
              class="col-2 px-0 border-bottom child"
              v-if="FnbHiddenMenus == false"
            >
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>

                  <span class="mx-1 relative" style="top: -1px">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                    >
                      <circle
                        id="Ellipse_39"
                        data-name="Ellipse 39"
                        cx="3"
                        cy="3"
                        r="3"
                        transform="translate(0)"
                        fill="#969696"
                      />
                    </svg>
                  </span>

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="6"
                    height="6"
                    viewBox="0 0 6 6"
                  >
                    <circle
                      id="Ellipse_39"
                      data-name="Ellipse 39"
                      cx="3"
                      cy="3"
                      r="3"
                      transform="translate(0)"
                      fill="#969696"
                    />
                  </svg>
                </div>
                <div>Options</div>
              </button>
            </div>

            <div
              class="col-2 px-0 border-bottom child"
              v-if="FnbHiddenMenus == true"
            >
              <button
                class="btn-pos-menu border-0"
                v-on:click="showHiddenMenus()"
              >
                <div class="svg-container">
                  <img src="@/assets/img/icons/close-x.svg" width="20" alt />
                </div>
                <div>Close</div>
              </button>
            </div>

            <div
              v-if="isMenuActive(1) && FnBItemsModule"
              class="col-2 px-0 border-bottom child"
            >
              <button
                @click="
                  setOnFnBPayloads({
                    event: $event,
                    name: 'category',
                    fc_id: null,
                    allCategory: true,
                  })
                "
                :class="['btn-pos-menu ', { active: category == null }]"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    width="30"
                    height="30"
                    viewBox="0 0 27.923 41.955"
                  >
                    <defs>
                      <clipPath id="clip-path">
                        <rect width="27.923" height="41.955" fill="none" />
                      </clipPath>
                    </defs>
                    <g id="noun_Popcorn_2663422" clip-path="url(#clip-path)">
                      <g id="Group_386" data-name="Group 386">
                        <path
                          id="Path_1167"
                          data-name="Path 1167"
                          d="M44.646,9.973H16.723a3.992,3.992,0,0,1,3.989-3.989A4.015,4.015,0,0,1,25.457,2.07,3.977,3.977,0,0,1,28.934,0,3.933,3.933,0,0,1,32.4,2.139,5.507,5.507,0,0,1,35.671,1a4.818,4.818,0,0,1,4.92,4.055A4.818,4.818,0,0,1,44.646,9.973ZM21.194,22.789l-.787-10.615H17.266l3.969,29.781h1.427l-.933-12.142A6.327,6.327,0,0,1,21.194,22.789Zm3.732,19.166h4.613V33.848A11.862,11.862,0,0,1,24.2,32.1Zm6.9,0h4.613l.729-9.856a11.871,11.871,0,0,1-5.342,1.748ZM30.684,20.192c-4.42,0-8.018,2.569-8.018,5.727s3.6,5.727,8.018,5.727S38.7,29.077,38.7,25.919,35.105,20.192,30.684,20.192Zm-1.145-2.2V12.174H22.671l.626,8.172A11.612,11.612,0,0,1,29.539,17.99Zm8.532,2.356.626-8.172H31.83V17.99A11.612,11.612,0,0,1,38.071,20.347Zm2.072,2.4a6.321,6.321,0,0,1-.533,7.107l-.9,12.1h1.427L44.1,12.174H40.935Z"
                          transform="translate(-16.723)"
                          fill="#969696"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <span>All</span>
              </button>
            </div>

            <div class="category-scroll">
              <div v-if="FnBItemsModule">
                <button class="btn-pos-menu px-2" @click="opencategoryPopup()">
                  <div class="svg-container">
                    <img src="@/assets/img/icons/Categories.png" />
                  </div>
                  Categories</button
                >
              </div>

              <div
                v-if="isMenuActive(2) && FnBItemsModule"
                class="col-2 px-0 border-bottom child"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="showPickupPage('PosFnbPickup')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27"
                      height="27"
                      viewBox="0 0 50.334 40.34"
                    >
                      <g
                        id="noun_box_office_19312"
                        data-name="noun_box office_19312"
                        transform="translate(0 -10.06)"
                      >
                        <g id="Group_314" data-name="Group 314">
                          <g id="Group_313" data-name="Group 313">
                            <path
                              id="Path_1091"
                              data-name="Path 1091"
                              d="M35.117,39.266a4.011,4.011,0,1,1,4.015-4.008A4.013,4.013,0,0,1,35.117,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1092"
                            data-name="Path 1092"
                            d="M34.236,50.055l.13-.084h.007l4.945-5.1a.532.532,0,1,1,.765.739l-4.592,4.735H46.259a22.475,22.475,0,0,0-4.772-9.213c-.957-1.157-3.522-2.261-5.292-.594A11.614,11.614,0,0,0,33.4,46.023l-4.509-4.562a1.863,1.863,0,0,0-2.651,2.619L31.9,49.8a1.87,1.87,0,0,0,2.339.254Z"
                            fill="#969696"
                          />
                        </g>
                        <g id="Group_316" data-name="Group 316">
                          <g id="Group_315" data-name="Group 315">
                            <path
                              id="Path_1093"
                              data-name="Path 1093"
                              d="M11.14,39.266a4.011,4.011,0,1,0-4.013-4.008A4.013,4.013,0,0,0,11.14,39.266Z"
                              fill="#969696"
                            />
                          </g>
                          <path
                            id="Path_1094"
                            data-name="Path 1094"
                            d="M12.02,50.055l-.129-.084h-.005l-4.946-5.1a.532.532,0,0,0-.765.739l4.593,4.735H0a22.475,22.475,0,0,1,4.772-9.213c.955-1.157,3.522-2.261,5.292-.594a11.612,11.612,0,0,1,2.793,5.484l4.51-4.562a1.863,1.863,0,0,1,2.65,2.619L14.361,49.8a1.872,1.872,0,0,1-2.341.254Z"
                            fill="#969696"
                          />
                        </g>
                        <path
                          id="Path_1095"
                          data-name="Path 1095"
                          d="M21.349,23.732V33.985h3.62v-6.65H46.714V50.4h3.62V23.732Z"
                          fill="#969696"
                        />
                        <rect
                          id="Rectangle_213"
                          data-name="Rectangle 213"
                          width="3.62"
                          height="13.323"
                          transform="translate(21.349 37.077)"
                          fill="#969696"
                        />
                        <path
                          id="Path_1096"
                          data-name="Path 1096"
                          d="M45.635,13.034V10.06H40.559V11.7H39.113V10.06H26.6v2.975a2.6,2.6,0,0,1,0,5.2v2.973H39.113V19.57h1.446v1.642h5.076V18.24a2.6,2.6,0,0,1,0-5.206ZM40.559,18H39.113V16.354h1.446Zm0-3.165H39.113V13.187h1.446Z"
                          fill="#969696"
                        />
                      </g>
                    </svg>
                  </div>
                  <div>{{ $t("pickup") }} {{ $tc("fnb", 1) }}</div>
                </button>
              </div>

              
              <!-- FNB REFUND ## -->
              <div v-if="FnBItemsModule" class="col-2 px-0 border-bottom child">
                <button
                  class="btn-pos-menu"
                  @click="showPickupPage('FnbRefund')"
                >
                  <div class="svg-container">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="29.888"
                      height="27.632"
                      viewBox="0 0 29.888 27.632"
                    >
                      <path
                        d="M58.485,84.785A1.169,1.169,0,0,1,60.416,86.1,13.816,13.816,0,1,1,62.4,74.956l.477-.818A1.171,1.171,0,0,1,64.9,75.319l-2.175,3.72a1.17,1.17,0,0,1-1.773.294L57.8,76.6a1.168,1.168,0,0,1,1.529-1.766l.82.71a11.476,11.476,0,1,0-1.66,9.244ZM47.992,69.939h2.23v1.92c2.013.291,3.559,1.4,3.643,3.779l-2.555.088a1.91,1.91,0,0,0-1.088-1.633v2.813c2.186.564,4.013,1.4,4.013,4.047a3.693,3.693,0,0,1-2.306,3.439,6.019,6.019,0,0,1-1.707.41v1.89h-2.23V84.775a4.354,4.354,0,0,1-4.013-4.239l2.485-.246A2.638,2.638,0,0,0,47.992,82.5V78.979c-1.839-.527-3.537-1.453-3.537-3.671,0-2.152,1.688-3.181,3.537-3.454V69.939Zm2.23,9.6v3.033a1.7,1.7,0,0,0,1.458-1.605c0-.755-.679-1.167-1.458-1.428ZM47.992,76.3V74.022c-.582.158-1.105.486-1.105,1.117C46.887,75.7,47.393,76.058,47.992,76.3Z"
                        transform="translate(-35.19 -64.5)"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Refund FNB</div>
                </button>
              </div>

              <!--Fnb Transaction-->

              <div
                v-if="isMenuActive(2) && FnBItemsModule"
                class="col-2 px-0 border-bottom child"
              >
                <button
                  class="btn-pos-menu"
                  v-on:click="showPickupPage('posUserFnbTransaction')"
                >
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      style="enable-background: new 0 0 100 100"
                      xml:space="preserve"
                    >
                      <path
                        d="M41.6,99.3H5.8c-1,0-1.9-0.8-1.9-1.9V2.7c0-1,0.8-1.9,1.9-1.9h60c0.5,0,1,0.2,1.3,0.5l17.3,17  c0.4,0.4,0.6,0.8,0.6,1.4V37c0,1-0.8,1.9-1.9,1.9c-1,0-1.9-0.8-1.9-1.9V20.5L65,4.6H7.7v90.8h33.8c1,0,1.9,0.8,1.9,1.9  S42.6,99.3,41.6,99.3z"
                      ></path>
                      <path
                        d="M18.9,33.3H59c1.2,0,2.2-1,2.2-2.2S60.2,29,59,29H18.9c-1.2,0-2.2,1-2.2,2.2S17.7,33.3,18.9,33.3z"
                      ></path>
                      <path
                        d="M19.1,21.2h40.1c1.2,0,2.2-1,2.2-2.2c0-1.2-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2  C17,20.3,17.9,21.2,19.1,21.2z"
                      ></path>
                      <path
                        d="M19.1,45.7h23.4c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2H19.1c-1.2,0-2.2,1-2.2,2.2S17.9,45.7,19.1,45.7z"
                      ></path>
                      <path
                        d="M33.7,58.5H19c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h14.6c1.2,0,2.2,1,2.2,2.2S34.9,58.5,33.7,58.5z"
                      ></path>
                      <path
                        d="M70.8,65.3c0,0.7,0.6,1.2,1.3,1.2c0,0,0,0,0,0c0.7,0,1.3-0.6,1.3-1.3c0-1.9-1.3-5.5-5.9-6v-1.4  c0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3v1.4c-1.7,0.2-3.1,0.8-4.2,1.9c-1.6,1.6-1.7,3.7-1.7,4.1c0,0.5-0.1,2.7,1.5,4.4  c1,1.1,2.5,1.8,4.4,2v7.5c-3.1-0.6-3.3-3-3.3-3.5c0-0.7-0.6-1.3-1.3-1.2c-0.7,0-1.3,0.6-1.3,1.3c0,1.9,1.3,5.5,5.9,6v1.4  c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-1.4c1.7-0.2,3.1-0.8,4.2-1.9c1.6-1.6,1.7-3.7,1.7-4.1c0-0.5,0.1-2.7-1.5-4.4  c-1-1.1-2.5-1.8-4.4-2v-7.5C70.5,62.3,70.8,64.7,70.8,65.3z M64.9,69.1c-1.1-0.2-1.9-0.5-2.5-1.2c-1-1.1-0.8-2.5-0.8-2.5  c0-0.1,0-0.1,0-0.2c0,0,0-1.4,1-2.4c0.6-0.6,1.3-0.9,2.3-1.1V69.1z M70,72.9c1,1.1,0.8,2.5,0.8,2.5c0,0.1,0,0.1,0,0.2  c0,0,0,1.4-1,2.4c-0.6,0.6-1.3,0.9-2.3,1.1v-7.4C68.6,72,69.4,72.3,70,72.9z"
                      ></path>
                      <path
                        d="M66.8,41.6C50.9,41.6,38,54.5,38,70.4s12.9,28.8,28.8,28.8s28.8-12.9,28.8-28.8S82.7,41.6,66.8,41.6z   M93,69.1h-3.1c-0.3-5.4-2.5-10.4-5.9-14.2l2.1-2.1C90.2,57.1,92.7,62.9,93,69.1z M82.2,53.1c-3.9-3.6-9.1-5.8-14.7-6v-2.8  c6.5,0.2,12.4,2.7,16.9,6.7L82.2,53.1z M64.9,47.1c-5.6,0.4-10.6,2.7-14.4,6.3l-1.8-1.8c4.3-4.1,10-6.8,16.3-7.3V47.1z M48.7,55.3  c-3.2,3.8-5.2,8.6-5.5,13.8h-2.5c0.3-6,2.6-11.4,6.2-15.7L48.7,55.3z M43.2,71.7c0.3,5.5,2.5,10.5,6,14.4L47.4,88  c-3.9-4.4-6.4-10-6.7-16.2H43.2z M51,88c3.8,3.3,8.6,5.5,13.9,5.8v2.8c-6-0.4-11.5-2.9-15.7-6.8L51,88z M67.5,93.8  c5.4-0.2,10.3-2.3,14.2-5.5l2.1,2.1c-4.4,3.8-10.1,6.1-16.3,6.2V93.8z M66.5,91C55.2,91,46,81.8,46,70.4c0-11.3,9.2-20.5,20.5-20.5  c11.3,0,20.5,9.2,20.5,20.5C87.1,81.8,77.9,91,66.5,91z M85.7,88.6l-2.1-2.1c3.7-3.9,6-9.1,6.4-14.8H93C92.7,78.3,90,84.2,85.7,88.6  z"
                      ></path>
                    </svg>
                  </div>
                  <div>Fnb Transactions</div>
                </button>
              </div>

              <div class="col-2 px-0 border-bottom child">
                <button
                  class="btn-pos-menu"
                  :disabled="btnDisable"
                  :class="btnDisable ? 'btnDisable' : ''"
                  v-on:click="onClickFooterBtn('Refresh')"
                >
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>{{ $t("refresh") }}</div>
                </button>
              </div>

              <!--Old Design Start--->
              <div
                v-for="(fnbCategory, fnbCategoryIndex) in fnbMoreCategoriesItem"
                :key="fnbCategoryIndex"
                class="w-100"
                style="white-space:nowrap;"
                v-if="
                  false &&
                    isMenuActive(1) &&
                    FnBItemsModule &&
                    fnbCategory.totalCategoryFnbItems > 0
                "
              >
                <!-- fnbCategories -->

                <button
                  @click="
                    setOnFnBPayloads({
                      event: $event,
                      name: 'category',
                      fc_id: fnbCategory.fc_id,
                    })
                  "
                  class="px-2"
                  :class="[
                    'btn-pos-menu ',
                    { active: category == fnbCategory.fc_id },
                  ]"
                >
                  <div class="svg-container">
                    <img
                      :src="
                        fnbCategory.fc_icon_active_url
                          ? _GetImagePath(fnbCategory.fc_icon_active_url)
                          : fnbCategory.fc_icon_url
                      "
                      height="auto"
                      width="40"
                    />
                    <!---alt="fnbCategory.fc_category"-->
                  </div>
                  <span>{{ fnbCategory.fc_category }} </span>
                </button>
              </div>

              <!--Old Design End--->
            </div>

            <div class="col-2 px-0 border-bottom child">
              <button
                class="btn-pos-menu"
                :disabled="btnDisable"
                :class="btnDisable ? 'btnDisable' : ''"
                v-on:click="onClickFooterBtn('Refresh')"
              >
                <div class="svg-container">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="27"
                    height="27"
                    viewBox="0 0 20 17"
                  >
                    <path
                      id="Icon"
                      d="M733-328v-6h4v6h5v-8h3l-10-9-10,9h3v8Z"
                      transform="translate(-725 345)"
                      fill="#969696"
                      fill-rule="evenodd"
                    />
                  </svg>
                </div>
                <div>Home</div>
              </button>
            </div>
          </div>
          <div class="Fnb-hidden-menus" v-if="FnbHiddenMenus">
            <div class="row h-100" style="flex-wrap:nowrap">
              <div v-if="FnBItemsModule" class="col-2 px-0 border-bottom child">
                <button
                  class="btn-pos-menu"
                  v-on:click="
                    $router.push({
                      name: 'Kitchen Pickup',
                      query: { isFnbOperator: true },
                    })
                  "
                >
                  <div class="svg-container">
                    <svg
                      height="40px"
                      viewBox="0 -24 480 480"
                      width="40px"
                      fill="#969696"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m472 96h-106.664062l-37.953126-91.078125c-1.242187-2.980469-4.152343-4.921875-7.382812-4.921875h-136c-4.417969 0-8 3.582031-8 8v32c0 4.417969 3.582031 8 8 8h106.457031l18 48h-60.457031c-4.417969 0-8 3.582031-8 8v48c0 4.417969 3.582031 8 8 8h8.457031l15.542969 264.472656c.25 4.230469 3.757812 7.535156 8 7.527344h160c4.242188.007812 7.75-3.296875 8-7.527344l15.542969-264.472656h8.457031c4.417969 0 8-3.582031 8-8v-48c0-4.417969-3.582031-8-8-8zm-168.503906-58.808594c-1.171875-3.125-4.160156-5.195312-7.496094-5.191406h-104v-16h122.664062l33.335938 80h-22.457031zm133.664062 298.808594h-34.96875c13.859375-12.101562 21.808594-29.601562 21.808594-48s-7.949219-35.898438-21.808594-48h40.617188zm-29.160156-48c0 26.507812-21.492188 48-48 48s-48-21.492188-48-48 21.492188-48 48-48c26.5.027344 47.972656 21.5 48 48zm-112 0c.011719 18.394531 7.960938 35.890625 21.808594 48h-34.96875l-5.648438-96h40.617188c-13.847656 12.109375-21.796875 29.605469-21.808594 48zm-8.457031 128-3.757813-64h152.429688l-3.757813 64zm156.210937-192h-167.507812l-3.757813-64h175.023438zm20.246094-80h-208v-32h208zm0 0"
                      />
                      <path
                        d="m408 384h-24c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h24c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m352 384h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8zm0 0"
                      />
                      <path
                        d="m24 432h208c13.253906 0 24-10.746094 24-24v-32c-.015625-8.21875-4.242188-15.855469-11.199219-20.230469 4.273438-7.265625 4.273438-16.273437 0-23.539062 6.957031-4.375 11.183594-12.011719 11.199219-20.230469 0-43.257812-29.921875-88-80-88h-88c-57.777344 0-88 44.273438-88 88 .015625 8.21875 4.242188 15.855469 11.199219 20.230469-4.273438 7.265625-4.273438 16.273437 0 23.539062-6.957031 4.375-11.183594 12.011719-11.199219 20.230469v32c0 13.253906 10.746094 24 24 24zm216-24c0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8v-32c0-4.417969 3.582031-8 8-8h62.953125l118.984375 31.726562c3.667969.984376 7.523438-.75 9.222656-4.152343l13.785156-27.574219h3.054688c4.417969 0 8 3.582031 8 8zm-216-64c0-4.417969 3.582031-8 8-8h192c4.417969 0 8 3.582031 8 8s-3.582031 8-8 8h-192c-4.417969 0-8-3.582031-8-8zm187.054688 24-7.292969 14.59375-54.714844-14.59375zm-123.054688-128h88c44.144531 0 64 42.105469 64 72 0 4.417969-3.582031 8-8 8h-208c-4.417969 0-8-3.582031-8-8 0-28.945312 19.199219-72 72-72zm0 0"
                      />
                      <path
                        d="m88 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m56 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m96 296c0 4.417969 3.582031 8 8 8h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8zm0 0"
                      />
                      <path
                        d="m152 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m200 304h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m128 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                      <path
                        d="m168 272h8c4.417969 0 8-3.582031 8-8s-3.582031-8-8-8h-8c-4.417969 0-8 3.582031-8 8s3.582031 8 8 8zm0 0"
                      />
                    </svg>
                  </div>
                  <div>Kitchen Display</div>
                </button>
              </div>

              <div
                v-if="FnBItemsModule && false"
                class="col-2 px-0 border-bottom child"
              >
                <button class="btn-pos-menu" @click="onClickTestPrint()">
                  <div class="test-print"></div>
                  <div>Test Print</div>
                </button>
              </div>

              <div
                v-if="isMenuActive(3) && FnBItemsModule"
                class="col-2 px-0 border-bottom child"
              >
                <button
                  v-on:click="showPickupPage('PosMultiFnB')"
                  :class="['btn-pos-menu', multifnbFlag ? 'active' : '']"
                >
                  <div class="svg-container">
                    <div>
                      <svg
                        width="51"
                        height="50"
                        viewBox="0 0 51 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.6621 24.0703L30.084 21.5469H32.498L30.0918 25.6875L32.5996 30H30.1777L28.6699 27.3438L27.1699 30H24.7402L27.248 25.6875L24.8496 21.5469H27.2715L28.6621 24.0703Z"
                          fill="#969696"
                        />
                        <path
                          d="M50.3682 34H37.6982V31.4863L43.6777 25.1133C44.4987 24.2161 45.1038 23.4333 45.4932 22.7646C45.891 22.096 46.0898 21.4613 46.0898 20.8604C46.0898 20.0394 45.8825 19.3962 45.4678 18.9307C45.0531 18.4567 44.4606 18.2197 43.6904 18.2197C42.861 18.2197 42.2051 18.5075 41.7227 19.083C41.2487 19.6501 41.0117 20.3991 41.0117 21.3301H37.3301C37.3301 20.2044 37.5967 19.1761 38.1299 18.2451C38.6715 17.3141 39.4333 16.5863 40.415 16.0615C41.3968 15.5283 42.5098 15.2617 43.7539 15.2617C45.6582 15.2617 47.1351 15.7188 48.1846 16.6328C49.2425 17.5469 49.7715 18.8376 49.7715 20.5049C49.7715 21.4189 49.5345 22.3499 49.0605 23.2979C48.5866 24.2458 47.7741 25.3503 46.623 26.6113L42.4209 31.042H50.3682V34Z"
                          fill="#969696"
                        />
                        <path
                          d="M9.9808 11C6.13159 11 3 13.6986 3 17.0156V30.1406C3 31.0453 3.85407 31.7812 4.90385 31.7812H8.07695V37.3594C8.07695 38.264 8.93101 39 9.9808 39C11.0306 39 11.8847 38.264 11.8847 37.3594V31.7812H15.0577C16.1075 31.7812 16.9616 31.0453 16.9616 30.1406V17.0156C16.9616 13.6986 13.83 11 9.9808 11ZM10.6154 37.3594C10.6154 37.6609 10.3307 37.9062 9.9808 37.9062C9.63087 37.9062 9.34618 37.6609 9.34618 37.3594V31.7812H10.6154V37.3594ZM15.0577 30.6875H4.90385C4.55393 30.6875 4.26924 30.4422 4.26924 30.1406V23.4306C4.45607 23.5239 4.67241 23.5781 4.90385 23.5781C5.60485 23.5781 6.17309 23.0885 6.17309 22.4844V20.2969C6.17309 19.6928 6.74133 19.2031 7.44233 19.2031C8.14333 19.2031 8.71156 19.6928 8.71156 20.2969V22.4844C8.71156 23.0885 9.2798 23.5781 9.9808 23.5781C10.6818 23.5781 11.25 23.0885 11.25 22.4844V18.1094C11.25 17.5053 11.8183 17.0156 12.5193 17.0156C13.2203 17.0156 13.7885 17.5053 13.7885 18.1094V20.2969C13.7885 20.901 14.3567 21.3906 15.0577 21.3906C15.2892 21.3906 15.5055 21.3364 15.6924 21.2431V30.1406C15.6924 30.4422 15.4077 30.6875 15.0577 30.6875Z"
                          fill="#969696"
                        />
                        <path
                          d="M13.7909 29.5937C14.1414 29.5937 14.4255 29.3489 14.4255 29.0469C14.4255 28.7448 14.1414 28.5 13.7909 28.5C13.4404 28.5 13.1562 28.7448 13.1562 29.0469C13.1562 29.3489 13.4404 29.5937 13.7909 29.5937Z"
                          fill="#969696"
                        />
                        <path
                          d="M12.5204 28.2266C12.6957 28.2266 12.8377 28.1041 12.8377 27.9531C12.8377 27.8021 12.6957 27.6797 12.5204 27.6797C12.3452 27.6797 12.2031 27.8021 12.2031 27.9531C12.2031 28.1041 12.3452 28.2266 12.5204 28.2266Z"
                          fill="#969696"
                        />
                      </svg>
                    </div>
                  </div>
                  <div>{{ $t("multifnb") }}</div>
                </button>
              </div>

              <div class="col-2 px-0 border-bottom child">
                <button class="btn-pos-menu" 
                  :disabled="btnDisable"
                  :class="btnDisable ? 'btnDisable' : ''"
                  @click="onClickHardReload()">
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Hard Reload</div>
                </button>
              </div>

              <div
                v-if="!FnBItemsModule && false"
                class="col-2 px-0 border-bottom child"
              >
                <button
                  class="btn-pos-menu "
                  @click="splitPaymentModal = !splitPaymentModal"
                >
                  <SplitPayment
                    v-bind:showModal="splitPaymentModal"
                  ></SplitPayment>
                  <div class="svg-container">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M29.7263 5.89913L24.1014 0.274214C23.7358 -0.0914048 23.1414 -0.0914048 22.7758 0.274214L17.1509 5.89913C16.8827 6.16912 16.8021 6.57037 16.9465 6.92099C17.0909 7.27161 17.434 7.50035 17.8127 7.50035H20.6252V10.1066C20.6252 11.0609 20.1583 11.9384 19.3746 12.4578L15.949 14.7415C15.6284 14.9515 15.3134 15.1952 15.0003 15.4784C14.6871 15.1952 14.374 14.9534 14.0572 14.7452L10.6222 12.4559C9.84222 11.9384 9.37535 11.0609 9.37535 10.1066V7.50035H12.1878C12.5666 7.50035 12.9097 7.27161 13.054 6.92099C13.1984 6.57037 13.1178 6.16912 12.8515 5.89913L7.22663 0.274214C6.86102 -0.0914048 6.26665 -0.0914048 5.90103 0.274214L0.276119 5.89913C0.00799783 6.16912 -0.0726259 6.57037 0.0717469 6.92099C0.21612 7.27161 0.559239 7.50035 0.937983 7.50035H3.75044V10.1066C3.75044 12.9378 5.15479 15.5627 7.50601 17.1302L10.941 19.4195C11.7209 19.937 12.1878 20.8145 12.1878 21.7689V29.0625C12.1878 29.58 12.6078 30 13.1253 30H16.8752C17.3927 30 17.8127 29.58 17.8127 29.0625V21.7689C17.8127 20.8145 18.2796 19.937 19.0633 19.4177L22.4945 17.1302C24.8457 15.5627 26.2501 12.9378 26.2501 10.1066V7.50035H29.0625C29.4413 7.50035 29.7844 7.27161 29.9288 6.92099C30.0732 6.57037 29.9925 6.16912 29.7263 5.89913ZM25.3126 5.62538C24.7951 5.62538 24.3751 6.04537 24.3751 6.56287V10.1066C24.3751 12.3078 23.2839 14.3515 21.4539 15.5702L18.0265 17.8558C16.7177 18.7202 15.9377 20.1827 15.9377 21.7689V28.125H14.0628V21.7689C14.0628 20.1827 13.2828 18.7221 11.9778 17.8577L8.54661 15.5702C6.71664 14.3515 5.62541 12.3078 5.62541 10.1066V6.56287C5.62541 6.04537 5.20542 5.62538 4.68792 5.62538H3.20107L6.5629 2.26356L9.92472 5.62538H8.43787C7.92037 5.62538 7.50038 6.04537 7.50038 6.56287V10.1066C7.50038 11.6928 8.28037 13.1534 9.58535 14.0177L13.0222 16.309C13.4478 16.5883 13.8678 16.9558 14.3121 17.4358C14.6646 17.8202 15.3378 17.8202 15.6884 17.4358C16.1309 16.9558 16.5527 16.5883 16.9821 16.3052L20.4096 14.0196C21.7202 13.1553 22.5001 11.6928 22.5001 10.1066V6.56287C22.5001 6.04537 22.0802 5.62538 21.5627 5.62538H20.0758L23.4376 2.26356L26.7995 5.62538H25.3126V5.62538Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>Split Payments</div>
                </button>
              </div>
              <!-- Multi Currency -->
              <div v-if="!FnBItemsModule" class="col-2 px-0 border-bottom">
                <button
                  class="btn-pos-menu"
                  @click="multiCurrencyModal = !multiCurrencyModal"
                >
                  <MultiCurrency
                    v-bind:showModal="multiCurrencyModal"
                    v-bind:sectionType="'POS-FNB'"
                  ></MultiCurrency>
                  <div class="svg-container">
                    <svg
                      height="100px"
                      width="100px"
                      fill="#000000"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      version="1.1"
                      x="0px"
                      y="0px"
                      viewBox="0 0 96 96"
                      enable-background="new 0 0 96 96"
                      xml:space="preserve"
                    >
                      <path
                        d="M18.954,27.396l-5.912-1.12l-2.413,12.744H4.75v38.545h57.009v3.197h22.343v-8.598h-1.576v-5.598h3.154V57.97h-0.585  l6.38-15.977l-67.576-26.98L18.954,27.396z M14.237,28.03l4.149,0.786l0.751,0.143l0.75,0.142l3.685,0.698l0.751,0.142l0.751,0.143  l35.305,6.688l3.849,0.729l3.847,0.729l4.18,0.792h-2.196h-2.021h-2.023h-8.954h-1.203h-1.406h-1.965l-3.861-0.731l-1.56-0.296  l-1.26-0.238l-22.12-4.19l-0.751-0.143l-0.521-0.099l-0.14,0.737c-0.188,0.995-0.7,1.854-1.4,2.504  c-0.823,0.763-1.912,1.231-3.099,1.232c-0.286,0-0.576-0.027-0.86-0.082l-0.431-0.081l-0.307-0.059l-0.273,1.445H15.12h-0.808  h-2.157L14.237,28.03z M25.641,28.663l0.022-0.056c0.504,0.133,1.021,0.2,1.543,0.2c2.252-0.001,4.272-1.217,5.333-3.153  l20.562,8.21L25.641,28.663z M44.424,39.021h-0.42H21.505h-0.808h-0.807h-0.334c0.134-0.041,0.262-0.097,0.393-0.146  c0.352-0.137,0.688-0.301,1.006-0.498c0.437-0.271,0.837-0.593,1.192-0.964c0.629-0.657,1.126-1.447,1.413-2.344l20.52,3.887  L44.424,39.021z M61.759,73.974v0.764v1.328H6.25V64.222v-2.078V40.521h4.095h0.764h0.763h1.843h0.808h0.808h0.288h0.764h0.763  h2.147h0.808h0.808h21.729h0.962h1.027h3.818h2.477h1.161h0.261h0.547h0.808h2.675h0.101h1.017h0.95h1.964h9.367h2.022h2.021h2.199  v0.878v0.808v0.808v5.821v0.801v3.307v4.031v0.996h-0.188h-0.764h-0.764h-1.964v-8.432h-0.75c-2.529,0-4.587-2.059-4.587-4.588V44.2  h-6.854h-0.775h-0.774h-4.099h-2.267h-0.808h-0.191h-0.616h-0.705h-1.675h-0.016h-0.75h-0.753h-4.228h-0.309h-0.461h-0.768h-0.447  h-1.327H22.428H21.5h-1.004h-4.05h-0.763h-0.417v0.75c0,1.088-0.396,2.075-1.031,2.862c-0.617,0.765-1.465,1.328-2.446,1.574  c-0.277,0.069-0.563,0.109-0.857,0.126c-0.085,0.005-0.166,0.025-0.252,0.025h-0.517h-0.05H9.93v0.46v0.773v0.165v12.455v0.764  v0.764v2.131h0.75c2.529,0,4.587,2.058,4.587,4.586v0.75h34.081h4.031h4.031h2.771v0.525v0.754h1.577V73.974z M70.833,50.992v6.978  h-7.496v7.098h-0.003h-2.023h-1.129v0.356v2.215v0.764v0.764v0.222v0.807v0.691H59.89H49.492h-4.031H41.43H16.721  c-0.341-2.758-2.533-4.95-5.291-5.29v-0.394v-0.763v-0.764v-12.14v-0.544c0.148-0.019,0.287-0.063,0.432-0.091  c0.399-0.08,0.782-0.195,1.149-0.349c0.271-0.113,0.53-0.245,0.78-0.396c0.315-0.189,0.61-0.404,0.886-0.646  c0.355-0.312,0.685-0.65,0.96-1.035c0.572-0.804,0.957-1.75,1.084-2.776h4.809h0.8h0.776H37.62h1.002h1.085h1.008h0.747h0.756h3.412  h0.764h0.764h0.289h1.48h1.086h0.677h0.131h0.131h0.677h0.15h0.151h0.855h6.077h0.747h0.755h5.178  C65.883,48.459,68.075,50.651,70.833,50.992z M61.759,72.165h-0.077v-0.529v-0.034v-0.716v-0.092v-0.808V69.45v-0.764v-0.764v-1.355  h1.363h0.292h1.73h2.023h1.152h0.011h0.656h0.436h0.519h0.13h0.819h0.123h1.396h3.68h0.393v5.598h-0.393h-8.874h-0.143h-1.88h-2.022  H61.759z M77.982,73.761v0.648v1.373v3.48H63.259v-1.697v-0.75v-0.75v-1.045v-0.764v-0.592h0.905h2.687h2.022h2.022h5.117h0.583  h0.167h0.451h0.146h0.153h0.47V73.761z M78.659,66.805v3.239v0.792v1.229v0.1h-0.04h-0.212h-0.502v-0.232v-1.148v-4.031v-0.186  h0.035h0.719V66.805z M78.225,65.067h-0.712h-0.75h-0.08h-0.67h-0.137h-0.201h-1.195h-0.764h-1.383h-0.265h-0.485h-0.75h-0.285  h-0.11h-5.601V59.47h5.996h0.75h0.75h1.68h0.764h0.764h0.473h0.75h0.54h0.21h0.599h0.807h0.367h0.275v2.577v3.021h-0.572H78.225z   M80.236,79.263h-0.754v-5.598h0.754V79.263z M81.025,68.161v4.004h-0.866v-1.834V68.31v-1.742h0.695h0.171V68.161z M81.061,65.067  V64.03V59.47h0.753v2.674v2.022v0.901h-0.36H81.061z M82.602,73.665v5.598h-0.865v-5.598h0.789H82.602z M84.18,60.262v4.806h-0.866  v-2.636v-2.022V59.47h0.375h0.491V60.262z M89.525,42.829L83.48,57.97h-2.384l1.426-7.523l0.241-0.605l-0.118-0.047l1.711-9.028  L89.525,42.829z M81.243,49.133l-0.148,0.782l-0.75,3.961l-0.729,3.847l-0.047,0.247h-0.052H78.71h-0.808h-0.39V43.612v-0.808  v-0.808v-1.98l5.269,0.998L81.243,49.133z M79.686,38.9l-18.89-3.578L31.743,23.722l-0.277,0.697c-0.7,1.754-2.372,2.888-4.26,2.889  c-0.582,0-1.153-0.111-1.7-0.329L24.81,26.7l-0.67,1.679l-3.685-0.698l4.279-10.719L79.686,38.9z"
                      ></path>
                      <path
                        d="M50.771,56.25c-0.054-0.253-0.12-0.501-0.192-0.747c-0.076-0.257-0.166-0.507-0.263-0.755  c-0.335-0.866-0.79-1.671-1.343-2.398c-0.173-0.228-0.354-0.445-0.546-0.656c-0.05-0.056-0.099-0.111-0.149-0.165  c-0.137-0.145-0.278-0.284-0.424-0.42c-0.246-0.23-0.503-0.446-0.771-0.65c-0.234-0.179-0.476-0.347-0.726-0.504  c-0.002-0.001-0.003-0.002-0.005-0.003c-0.224-0.141-0.452-0.275-0.688-0.397c-0.057-0.03-0.116-0.056-0.174-0.085  c-0.03-0.015-0.061-0.028-0.091-0.043c-0.146-0.07-0.286-0.147-0.435-0.21c-0.73-0.31-1.509-0.521-2.316-0.646  c-0.056-0.009-0.111-0.018-0.168-0.025c-0.191-0.026-0.385-0.05-0.58-0.064c-0.073-0.006-0.147-0.007-0.221-0.012  c-0.179-0.01-0.356-0.026-0.538-0.027c-0.003,0-0.006,0-0.009,0c-0.075,0-0.148,0.01-0.224,0.012  c-1.265,0.028-2.473,0.289-3.577,0.752c-0.314,0.133-0.621,0.28-0.918,0.443c-0.313,0.171-0.611,0.361-0.902,0.564  c-1.037,0.724-1.929,1.641-2.622,2.7c-0.139,0.212-0.273,0.427-0.396,0.649c-0.121,0.22-0.227,0.447-0.331,0.676  c-0.505,1.112-0.805,2.333-0.861,3.618c-0.007,0.146-0.022,0.29-0.022,0.438c0,0.124,0.014,0.244,0.019,0.367  c0.011,0.28,0.028,0.559,0.062,0.832c0.122,0.999,0.395,1.951,0.793,2.836c0.131,0.289,0.274,0.57,0.432,0.845  c0.172,0.301,0.361,0.591,0.563,0.87c1.791,2.48,4.699,4.104,7.985,4.104c1.966,0,3.794-0.585,5.333-1.58  c0.291-0.188,0.572-0.388,0.841-0.604c0.028-0.023,0.061-0.043,0.089-0.066c0.215-0.178,0.418-0.366,0.617-0.562  c0.001,0,0.001-0.001,0.002-0.001c0.191-0.188,0.372-0.385,0.548-0.587c0.813-0.935,1.45-2.023,1.867-3.217  c0.083-0.236,0.155-0.476,0.22-0.72c0.063-0.239,0.121-0.479,0.167-0.726c0.001-0.005,0.001-0.01,0.002-0.015  c0.062-0.337,0.104-0.681,0.131-1.028c0.019-0.248,0.038-0.495,0.038-0.748c0-0.092-0.012-0.182-0.014-0.272  C50.956,57.416,50.892,56.823,50.771,56.25z M49.438,59.186c-0.012,0.106-0.033,0.209-0.049,0.314  c-0.029,0.207-0.063,0.413-0.108,0.614c-0.01,0.046-0.023,0.091-0.035,0.136c-0.059,0.246-0.128,0.488-0.208,0.725  c-0.011,0.032-0.024,0.064-0.035,0.097c-0.414,1.167-1.073,2.219-1.926,3.083c-0.194,0.197-0.398,0.386-0.611,0.563  c-0.109,0.091-0.227,0.173-0.34,0.258c-0.121,0.091-0.24,0.184-0.366,0.268c-0.173,0.116-0.353,0.223-0.534,0.325  c-0.374,0.211-0.767,0.39-1.172,0.542c-0.911,0.342-1.893,0.537-2.921,0.537c-2.142,0-4.09-0.816-5.57-2.146  c-0.322-0.29-0.627-0.599-0.901-0.935c-0.227-0.278-0.431-0.575-0.62-0.881c-0.481-0.773-0.84-1.628-1.048-2.541  c-0.064-0.284-0.116-0.573-0.15-0.867c-0.032-0.273-0.051-0.55-0.056-0.83c-0.001-0.052-0.008-0.102-0.008-0.154  c0-1.251,0.284-2.434,0.778-3.5c0.106-0.229,0.222-0.452,0.347-0.669c0.128-0.221,0.265-0.436,0.412-0.644  c0.309-0.436,0.656-0.84,1.04-1.208c0.239-0.229,0.494-0.442,0.76-0.643c0.251-0.19,0.513-0.366,0.785-0.526  c1.193-0.706,2.573-1.123,4.05-1.155c0.062-0.001,0.12-0.009,0.182-0.009c0.079,0,0.155,0.01,0.234,0.012  c0.111,0.003,0.223,0.01,0.333,0.017c0.163,0.012,0.325,0.025,0.485,0.046c0.093,0.012,0.185,0.027,0.276,0.042  c0.219,0.035,0.434,0.078,0.646,0.13c0.546,0.133,1.069,0.318,1.567,0.554c0.238,0.111,0.469,0.233,0.694,0.367  c0.072,0.043,0.145,0.086,0.215,0.131c0.118,0.074,0.235,0.15,0.35,0.231c0.039,0.027,0.076,0.057,0.114,0.085  c0.292,0.214,0.57,0.443,0.832,0.692c0.686,0.651,1.259,1.417,1.692,2.267c0.004,0.008,0.007,0.016,0.011,0.023  c0.137,0.269,0.257,0.546,0.364,0.831c0.054,0.145,0.113,0.287,0.16,0.436c0.036,0.115,0.061,0.235,0.091,0.353  c0.182,0.684,0.288,1.397,0.288,2.138C49.486,58.595,49.469,58.892,49.438,59.186z"
                      ></path>
                      <path
                        d="M45.434,58.729c-0.142-0.326-0.34-0.6-0.593-0.803c-0.201-0.162-0.437-0.277-0.697-0.349  c-0.188-0.052-0.386-0.088-0.602-0.088h-0.146H42.33h-0.448v-0.003v-0.176v-0.256v-0.552v-0.211v-0.765v-0.49V54.19h0.961h1.179  h0.427h0.067h0.27h0.247v-0.548V53.44v-0.556V52.69h-0.485h-0.241h-0.34h-1.008h-1.076V51.8v-0.412h-0.434h-0.316h-0.75v1.303  h-1.245c-0.483,0-0.91,0.081-1.267,0.241c-0.35,0.157-0.637,0.377-0.854,0.658c-0.004,0.006-0.007,0.012-0.011,0.018  c-0.178,0.235-0.303,0.497-0.386,0.794c-0.005,0.019-0.014,0.034-0.019,0.053c-0.027,0.105-0.043,0.223-0.061,0.337  c-0.019,0.119-0.032,0.242-0.041,0.371c-0.008,0.114-0.019,0.226-0.019,0.347v0.453v0.209c0,0.154,0.011,0.3,0.023,0.443  c0.02,0.217,0.049,0.425,0.097,0.614c0.085,0.329,0.221,0.612,0.417,0.864c0.213,0.275,0.498,0.496,0.851,0.656  c0.075,0.034,0.167,0.05,0.249,0.076c0.302,0.1,0.635,0.164,1.019,0.164h0.251h0.994v0.424v0.289v0.873v0.906v0.808v0.104h-1.76  h-0.561h-0.584v0.75v0.194v0.556h2.904v0.758v0.547h0.75h0.75v-0.263v-0.764v-0.278h0.497h1.163c0.224,0,0.428-0.039,0.622-0.095  c0.32-0.091,0.597-0.253,0.823-0.479c0.36-0.357,0.593-0.868,0.663-1.498c0.015-0.134,0.029-0.268,0.029-0.411v-0.343v-0.747v-0.348  c0-0.122-0.015-0.234-0.025-0.35C45.624,59.292,45.549,58.993,45.434,58.729z M40.382,55.903v0.809v0.777h-0.075h-1.17  c-0.084,0-0.154-0.01-0.229-0.017c-0.165-0.016-0.314-0.042-0.42-0.09c-0.124-0.057-0.222-0.128-0.284-0.209  c-0.069-0.089-0.116-0.189-0.149-0.316c-0.022-0.087-0.038-0.185-0.05-0.287c-0.015-0.123-0.023-0.254-0.023-0.396  c0-0.001,0-0.002,0-0.003v-0.418v-0.244c0-0.202,0.02-0.383,0.049-0.544c0.009-0.046,0.014-0.098,0.024-0.139  c0.033-0.129,0.081-0.231,0.149-0.321c0.062-0.079,0.158-0.15,0.279-0.204c0.161-0.072,0.387-0.11,0.653-0.11h1.245V55.903z   M44.18,60.27v0.754v0.388c0,0.145-0.013,0.262-0.031,0.367c-0.105,0.609-0.472,0.615-0.606,0.615h-0.876h-0.784V62.08v-0.826  v-0.796v-0.812v-0.657h1.66c0.423,0,0.638,0.331,0.638,0.984V60.27z"
                      ></path>
                    </svg>
                  </div>
                  <div>MultiCurrency</div>
                </button>
              </div>

              <!--
                <div class="col-2 px-0">
                  <button class="btn-pos-menu"></button>
                </div>
                -->

              <div
                v-if="FnBItemsModule && false"
                v-for="(fnbMoreCategory,
                fnbMoreCategoryIndex) in fnbMoreCategoriesItem.slice(
                  startValue,
                  endValue
                )"
                :key="fnbMoreCategoryIndex"
                class="col-2 px-0 border-bottom child"
              >
                <button
                  class="btn-pos-menu"
                  @click="
                    setOnFnBPayloads({
                      event: $event,
                      name: 'category',
                      fc_id: fnbMoreCategory.fc_id,
                    })
                  "
                  :class="[
                    'btn-pos-menu ',
                    { active: category == fnbMoreCategory.fc_id },
                  ]"
                >
                  <div class="svg-container">
                    <img
                      :src="_GetImagePath(fnbMoreCategory.fc_icon_active_url)"
                    />
                  </div>
                  <span>{{ fnbMoreCategory.fc_category }}</span>
                </button>
              </div>

              <div class="col-2 px-0 border-bottom child d-none">
                <button
                  class="btn-pos-menu"
                  v-on:click="loadmore()"
                  v-if="fnbMoreCategoriesItem.length != this.endValue"
                >
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>{{ $t("View More") }}</div>
                </button>
                <button v-else class="btn-pos-menu" v-on:click="loadless()">
                  <div class="svg-container">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.5511 0.925995C9.41815 0.917535 6.40535 2.13091 4.15282 4.30831V0.92594C4.15282 0.41455 3.73827 0 3.22688 0C2.71549 0 2.30099 0.41455 2.30099 0.92594V6.4815C2.30088 6.8802 2.55604 7.2342 2.93435 7.36015L8.4899 9.212C8.9757 9.3736 9.5005 9.11075 9.6621 8.625C9.8237 8.1392 9.56085 7.61435 9.07505 7.4528L4.97324 6.088C8.76235 1.96174 15.179 1.68842 19.3053 5.47755C23.4315 9.26665 23.7048 15.6834 19.9157 19.8096C16.1266 23.9358 9.70995 24.2091 5.5837 20.42C3.05397 18.097 1.87158 14.6516 2.44178 11.2648C2.53146 10.7613 2.19607 10.2805 1.69265 10.1908C1.18923 10.101 0.708385 10.4365 0.61865 10.9399C0.617675 10.9454 0.616755 10.9509 0.615885 10.9564C0.505045 11.6195 0.449273 12.2906 0.449219 12.9628C0.45676 19.6076 5.84145 24.9923 12.4861 24.9999C19.1339 25.0179 24.5376 19.6433 24.5556 12.9954C24.5735 6.34765 19.1989 0.943955 12.5511 0.925995Z"
                        fill="#969696"
                      />
                    </svg>
                  </div>
                  <div>{{ $t("Load Less") }}</div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <button @click="onSwtichModule({name:'showFnBOrderDetails'})">sjnajsna</button> -->

      <div class="col-md-3 col-lg-3 col-xl-3 col-sm-4 pl-0">
        <div class="pos-fnb-navigation">
          <!-- FNB SELECTION ROW -->
          <div class="row" v-if="FnBItemsModule">
            <div class="col-12 mb-2">
              <span id="tooltip-button-disable">
                <button
                  :disabled="SelectedFnbItemList.length === 0"
                  @click="onCheckShift()"
                  v-bind:style="{
                    'pointer-events':
                      SelectedFnbItemList.length === 0 ? 'none' : 'all',
                  }"
                  class="btn-blue-lg w-100"
                >
                  Proceed
                </button>
              </span>

              <b-tooltip
                :disabled="SelectedFnbItemList.length > 0"
                target="tooltip-button-disable"
                placement="top"
                >Please select something</b-tooltip
              >
            </div>

            <div class="col-12">
              <button
                @click="onResetFnBHandler"
                :class="[
                  'btn-white-lg w-100',
                  SelectedFnbItemList.length === 0 ? 'disabled' : null,
                ]"
              >
                Clear Selection
              </button>
            </div>
          </div>

          <!-- FNB CHECKOUT ROW -->
          <div class="row" v-if="!FnBItemsModule">
            <div class="col-12 mb-2">
              <span id="tooltip-checkout-button-disable">
                <button
                  class="btn-blue-lg w-100"
                  :class="[
                    ([2, 3].includes(selectedPaymentMode.pm_id) &&
                      (USE_TIM_INTEGRATION == 'Y' ||
                        USE_NEOLEAP_POS_PAYMENT == 'Y')) ||
                    disableCheckoutBtn
                      ? 'disabled'
                      : '',
                  ]"
                  v-bind:style="{
                    'pointer-events':
                      ([2, 3].includes(selectedPaymentMode.pm_id) &&
                        (USE_TIM_INTEGRATION == 'Y' ||
                          USE_NEOLEAP_POS_PAYMENT == 'Y')) ||
                      disableCheckoutBtn
                        ? 'none'
                        : 'all',
                  }"
                  @click="
                    onClickCheckout();
                  "
                >
                  Checkout
                </button>
              </span>

              <!-- v-if="selectedPaymentMode.pm_id == 1 && finalGrossAmount > cashInputValue" -->
              <!-- <b-tooltip
                id="checkout-tooltip"
                :disabled="
                  selectedPaymentMode.pm_id == 1 &&
                    !(cashInputValue < finalGrossAmount) &&
                    selectedPaymentMode.pm_id == 11 &&
                    !usedCashCards &&
                    usedCashCards.length == 0 &&
                    !(
                      selectedPaymentMode.pm_id == 10 &&
                      finalGrossAmount > cashInputValue
                    )
                "
                target="tooltip-checkout-button-disable"
                placement="top"
                >{{
                  selectedPaymentMode.pm_id != 11 &&
                  usedCashCards &&
                  usedCashCards.length > 0
                    ? "Please Proceed to split payment"
                    : (selectedPaymentMode.pm_id == 1 &&
                        finalGrossAmount > cashInputValue) ||
                      (selectedPaymentMode.pm_id == 10 &&
                        finalGrossAmount > cashInputValue)
                    ? "Please add more cash"
                    : "Make sure you have done your payment process."
                }}</b-tooltip
              > -->
            </div>

            <div v-if="!FnBItemsModule" class="col-6 pr-1">
              <button
                @click="
                  clearOffer();
                  onSwtichModule({ name: 'FnBItemsModule' });
                "
                class="btn-white-lg w-100"
              >
                Back
              </button>
            </div>

            <div class="col-6 pl-1">
              <button
                class="btn-white-lg w-100"
                v-on:click="onOpenCustomerPopupModal()"
              >
                <span class="fs-12"
                  >{{ $t(isOldCustomer ? "update" : "add") }}
                  {{ $t("customer") }} {{ $tc("details", 1) }}</span
                >
              </button>
            </div>
          </div>

          <div class="row">
            <!-- <div class="col-md-12 mb-2">
              <button @click="onSwtichModule({name: 'FnBItemsModule'})" class="btn-blue-lg w-100">Checkout</button>
            </div>-->
            <!-- <div v-if="FnBItemsModule" class="col-md-12 mb-2">
              <span id="tooltip-button-disable">
                <button
                  :disabled="SelectedFnbItemList.length ===0"
                  @click="onCheckShift()"
                  v-bind:style="{ 'pointer-events': SelectedFnbItemList.length === 0 ? 'none' : 'all' }"
                  class="btn-blue-lg w-100"
                >Proceed</button>
              </span>

              <b-tooltip
                :disabled="SelectedFnbItemList.length > 0"
                target="tooltip-button-disable"
                placement="top"
              >Please select something</b-tooltip>
            </div>-->

            <!-- <div v-if="!FnBItemsModule" :class="['col-md-6 mb-2' ]">
              <button
                class="btn-blue-lg w-100"
                v-on:click="onOpenCustomerPopupModal()"
              >{{ $t(isOldCustomer ? 'update' :'add') }} {{ $t('customer') }} {{ $tc('details',1) }}</button>
            </div>-->

            <!-- <div v-if="!FnBItemsModule" :class="['col-md-6 mb-2' ]">
              <span id="tooltip-checkout-button-disable">
                <button
                  class="btn-blue-lg w-100"
                  v-bind:style="{ 'pointer-events': selectedPaymentMode.pm_id == 1 && cashInputValue < finalGrossAmount ? 'none' : 'all' }"
                  @click="onOrderSubmit"
                >
                  Checkout
                  {{ selectedPaymentMode.pm_id == 1 }} {{ !(cashInputValue < finalGrossAmount) }} {{ cashInputValue < finalGrossAmount }} {{ cashInputValue +'-'+ finalGrossAmount}}
                </button>
              </span>

              <b-tooltip
                :disabled="selectedPaymentMode.pm_id == 1 && !(cashInputValue < finalGrossAmount)"
                target="tooltip-checkout-button-disable"
                placement="top"
              >
                {{ selectedPaymentMode.pm_id == 1 ? 'Please add more cash': 'Make sure you have done your payment process.' }}
                {{isPaymentTypeCash.cashPayments && !(cashInputValue < finalGrossAmount)}}
              </b-tooltip>
            </div>-->
            <!-- paymentTypes.cashPayments -->

            <!-- <div class="col-6 pr-2">
              <button @click="onResetFnBHandler" class="btn-white-lg w-100">Cancel</button>
            </div>-->
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="testprintFNBOptions"
      ref="testprintFNBOptions"
      title="Test Print"
      hide-footer
      hide-header
      size="sm"
      centered
    >
      <div class="text-center">
        <button
          @click="printHandler(3)"
          class="btn-blue-lg bg-blue text-white ml-1"
        >
          FNB
        </button>
        <button
          @click="printHandler(4)"
          class="btn-blue-lg bg-blue text-white ml-1"
        >
          Receipt
        </button>
      </div>
    </b-modal>

    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>

    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle
        @idle="onIdleCheckout"
        :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']"
        :loop="true"
        :duration="pos_final_page_standBy_time * 60"
      />
    </div>

    <CategoryPopup
      v-model="categoryModalPopup"
      :refId="'categoryPopup'"
    ></CategoryPopup>
  </footer>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";
  import { EventBus } from "@/main";
  import { BASEURL } from "@/config/index";
  import PosService from "@/services/PosService";
  import MasterService from "@/services/MasterService";
  import SplitPayment from "../Pages/PosFnbContainer/fnbSplitPayment";
  import MultiCurrency from "@/components/Partials/PosCurrencyConvertor.vue";
  import { directive as onClickaway } from "vue-clickaway";
  import Printd from "printd";
  import _ from "lodash";
  import CategoryPopup from "@/components/Partials/PosFnbCategoryPopup.vue";

  export default {
    components: {
      SplitPayment,
      MultiCurrency,
      CategoryPopup,
    },
    props: {
      onClickHandler: { type: Function },
    },
    directives: {
      onClickaway: onClickaway,
    },
    data() {
      return {
        btnDisable: false,
        disableCheckoutBtn: false,
        startValue: 0,
        endValue: 3,
        BASEURL,
        FnbHiddenMenus: false,
        multifnbFlag: false,
        splitPaymentModal: false,
        multiCurrencyModal: false,
        categoryModalPopup: false,
        EjsData: null,
      };
    },
    watch: {
      // multifnbFlag: function(newVal, oldVal) {
      //   this.$store.commit("SET_MULTI_FNB_FLAG", newVal);
      //   this.showPickupPage("PosMultiFnB");
      // }
    },
    computed: {
      GET_MERIT_GIFT_CARD_DETAILS() {
        return this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
      },
      MeritCardAmount() {
        let amount = 0;
        let gc_details = this.$store.getters.GET_MERIT_GIFT_CARD_DETAILS;
        if (gc_details) {
          amount = +parseFloat(gc_details["amount"]).toFixed(2);
        }
        return amount;
      },
      USE_TIM_INTEGRATION() {
        return this.$store.getters.USE_TIM_INTEGRATION;
      },
      USE_NEOLEAP_POS_PAYMENT() {
        return this.$store.getters.USE_NEOLEAP_POS_PAYMENT;
      },
      pos_final_page_standBy_time() {
        return parseInt(this.$store.getters.POS_FINAL_PAGE_STANDBY_TIME);
      },
      POS_AMOUNT_CALCULATION_CHECK() {
        return this.$store.getters.POS_AMOUNT_CALCULATION_CHECK;
      },
      isOldCustomer() {
        return this.$store.getters.getIsOldCustomer;
      },
      checkFinalAmount() {
        return (
          this.FnBItemsTotalPrice -
          this.getOfferPrice -
          parseFloat(this.MeritCardAmount || 0) -
          this.getloyaltyAmount +
          this.$store.getters.selectedAddonsTotalPrice +
          this.$store.getters.customizationTotalPrice
        );
      },
      finalGrossAmount() {
        return (
          this.FnBItemsTotalPrice -
          this.getOfferPrice -
          this.getloyaltyAmount -
          parseFloat(this.MeritCardAmount || 0) -
          this.paid_amount +
          this.$store.getters.selectedAddonsTotalPrice +
          this.$store.getters.customizationTotalPrice
        );
      },
      ...mapGetters([
        "fnbCategories",
        "fnbMoreCategories",
        "SelectedFnbItemList",
        "selectedPaymentMode",
        "getOfferPrice",
        "getloyaltyAmount",
        "paid_amount",
        "usedCashCards",

        // "MultiFnbFlag"
      ]),
      fnbMoreCategoriesItem() {
        let fnbItemNew =
          this.fnbCategories && this.fnbCategories.length
            ? _.orderBy(this.fnbCategories, "fc_category")
            : [];
        return fnbItemNew;
      },
      ...mapState({
        // SelectedFnbItemList: state => state.FnBStore.selectedFnbItemList,
        FnBItemsModule: (state) => state.FnBStore.FnBItemsModule,
        category: (state) => state.FnBStore.fnbPayload.category,
        selectedFnBItemsTotalPrice: (state) =>
          state.FnBStore.selectedFnBItemsTotalPrice,
        TotalAdditionalTaxes: (state) => state.FnBStore.totalAdditionalTaxes,
        cashInputValue: (state) => state.FnBStore.cashInputValue,
        FnBItemsTotalPrice: (state) =>
          state.FnBStore.selectedFnBItemsTotalPrice +
          state.FnBStore.totalAdditionalTaxes,
      }),
    },
    beforeMount() {
      EventBus.$on("enableCheckOutBtn", (data) => {
        console.log("enableCheckOutBtn", data);
        this.disableCheckoutBtn = false;
      });
    },
    methods: {
      onClickFooterBtn: _.debounce(function(menuName) {
      this.btnDisable = true;
      this.showPickupPage(menuName);
      setTimeout(() => {
        this.btnDisable = false;
      }, 1000);
    }, 200),
    onClickHardReload: _.debounce(function(menuName) {
      this.btnDisable = true;
      this.HARD_RELOAD_POS();
      setTimeout(() => {
        this.btnDisable = false;
      }, 1000);
    }, 200),
      opencategoryPopup() {
        this.$bvModal.show("categoryPopup");

        console.log(this.categoryModalPopup, "Status");
      },
      loadmore() {
        if (this.fnbMoreCategoriesItem.length < this.endValue + 3) {
          let diff = this.endValue - this.fnbMoreCategoriesItem.length;
          this.endValue = this.endValue - diff;
        } else {
          this.endValue = this.fnbMoreCategoriesItem.length;
        }
        console.log("More");
      },
      loadless() {
        this.endValue = 3;
        console.log("Less");
      },
      ...mapActions([
        "onSwtichModule",
        "onResetOffersAndPrice",
        "fetchFnBItems",
        "setOnFnBPayloads",
        "onResetFnBHandler",
        "onOrderSubmit",
        "GET_PAYMENT_MODES",
        "HARD_RELOAD_POS",
        //
        "GoToRoute",
        //
        // "SelectedFnbItemList",
      ]),
      clearOffer() {
        this.onResetOffersAndPrice();
      },
      printHandler(type) {
        this.$refs.testprintFNBOptions.hide();
        const { cinema_id } = this.secureStore.get("USINFO");
        var userAgent = navigator.userAgent.toLowerCase();
        if (userAgent.indexOf(" electron/") > -1) {
          try {
            if (this.$socket) {
              this.$socket.emit("on_print_ticket", {
                baseurl: BASEURL,
                ttype: "test_print",
                cinema_id: cinema_id,
                type: type,
              });
            }
          } catch (err) {
            console.log("Error:", err);
          }
        } else {
          this.printTest(type);
        }
      },
      printTest: function(type) {
        let loader = this.$loading.show();
        const { cinema_id } = this.secureStore.get("USINFO");
        let payload = {
          cinema_id: cinema_id,
          type: type,
        };

        MasterService.TestPrint(payload)
          .then((response) => {
            console.log("response :", response);

            if (response) {
              const { data } = response;

              this.EjsData = data;

              this.$nextTick(() => {
                loader.hide();
                const p = new Printd();
                if (this.$refs.onPrint && this.EjsData != null) {
                  p.print(this.$refs.onPrint, []);
                }
              });
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            loader.hide();
          });
      },
      onClickTestPrint() {
        this.$refs.testprintFNBOptions.show();
      },
      away: function() {
        let modalstate = document.querySelectorAll(".modal.show");
        console.log("modalstate", modalstate);
        if (!modalstate || (modalstate && modalstate.length == 0)) {
          this.FnbHiddenMenus = false;
        }
      },
      onIdleCheckout() {
        this.showPickupPage("Refresh");
      },
      onClickCheckout: _.debounce(function() {
        if (this.checkValidation()) {
          if (
            this.selectedPaymentMode.pm_id == 11 ||
            this.selectedPaymentMode.pm_id == 13 ||
            this.selectedPaymentMode.pm_id == 12 ||
            this.selectedPaymentMode.pm_id == 10 ||
            this.selectedPaymentMode.pm_id == 23
          ) {
            if (
              +parseFloat(this.checkFinalAmount).toFixed(2) >
              +parseFloat(this.paid_amount).toFixed(2)
            ) {
              let pm_object = {
                pm_id: 1,
                pm_payment_mode: "Cash",
              };
              this.$toasted.show("Please pay using Cash/Online payment");
              this.$store.dispatch("setPaymentMode", pm_object);
            } else {
              this.disableCheckoutBtn = true;
              this.onOrderSubmit({ isSplitPayment: false });
            }
          } else {
            this.disableCheckoutBtn = true;
            this.onOrderSubmit({ isSplitPayment: false });
          }
        } else {
          this.$toasted.show("Cash Input is less then Total Amount");
        }
      }, 300),
      checkValidation() {
        let status = false;
        if (
          (this.selectedPaymentMode.pm_id == 1 &&
            this.cashInputValue < this.finalGrossAmount &&
            this.POS_AMOUNT_CALCULATION_CHECK == "Y") ||
          (this.selectedPaymentMode.pm_id != 11 &&
            this.usedCashCards &&
            this.usedCashCards.length > 0) ||
          (this.selectedPaymentMode.pm_id == 10 &&
            this.finalGrossAmount > this.cashInputValue) ||
          ([2, 3].includes(this.selectedPaymentMode.pm_id) &&
            (this.USE_TIM_INTEGRATION == "Y" ||
              this.USE_NEOLEAP_POS_PAYMENT == "Y"))
        ) {
          status = false;
        } else {
          status = true;
        }

        return status;
      },
      _onClickCheckout() {
        if (this.checkValidation()) {
          if (
            this.selectedPaymentMode.pm_id == 11 ||
            this.selectedPaymentMode.pm_id == 13 ||
            this.selectedPaymentMode.pm_id == 12 ||
            this.selectedPaymentMode.pm_id == 10 ||
            this.selectedPaymentMode.pm_id == 23
          ) {
            if (
              +parseFloat(this.checkFinalAmount).toFixed(2) >
              +parseFloat(this.paid_amount).toFixed(2)
            ) {
              let pm_object = {
                pm_id: 1,
                pm_payment_mode: "Cash",
              };
              this.$toasted.show("Please pay using Cash/Online payment");
              this.$store.dispatch("setPaymentMode", pm_object);
            } else {
              this.disableCheckoutBtn = true;
              this.onOrderSubmit({ isSplitPayment: false });
            }
          } else {
            this.disableCheckoutBtn = true;
            this.onOrderSubmit({ isSplitPayment: false });
          }
        } else {
          this.$toasted.show("Cash Input is less then Total Amount");
        }
      },
      isMenuActive(id) {
        return true;
        //THIS IS BECAUSE WE HAVE REMOVED THE FOOTER MENU API TO OPTIMIZE THE POS
        if (
          this.$store.getters.getPosFnbFooterMenus &&
          this.$store.getters.getPosFnbFooterMenus.length > 0
        ) {
          let array = this.$store.getters.getPosFnbFooterMenus.filter((x) => {
            return x.pfbm_id == id && x.menu_is_active == "Y";
          });
          if (array && array.length > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      },
      showHiddenMenus: function() {
        this.FnbHiddenMenus = !this.FnbHiddenMenus;
      },
      onOpenCustomerPopupModal: function() {
        this.$root.$emit("bv::show::modal", "fnb-customer-details");
      },
      showPickupPage: async function(name) {
        if (name == "PosMultiFnB") {
          this.multifnbFlag = !this.multifnbFlag;
          await this.$store.commit("SET_MULTI_FNB_FLAG", this.multifnbFlag);
        }

        await this.onClickHandler(name);
      },
      onHideToolTip: function() {
        document.getElementById("checkout-tooltip").style.display = "none";
        // this.$root.$emit("bv::hide::tooltip");
      },
      onCheckShift: function() {
        PosService.shiftChecker().then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.shiftRunning) {
              let count = 0;
              this.SelectedFnbItemList.map((item) => {
                if (
                  item.is_customization_available &&
                  item.is_customization_available == "Y" &&
                  item.is_customization_compulsory &&
                  item.is_customization_compulsory == "Y"
                ) {
                  if (
                    item.hasOwnProperty("customizations") &&
                    item.customizations.length == 0
                  ) {
                    count++;
                    this.$toasted.show(
                      "Please add customization for " + item.item_name
                    );
                    return;
                  }
                }
              });
              if (count == 0) {
                this.onSwtichModule({ name: "FnBItemsModule" });
                this.GET_PAYMENT_MODES(5);
              }
            } else {
              this.$store.dispatch("onSetAndSendLog", {
                action: "FNB User Loged out",
                page_name: "FNB booking",
                api_name: window.location.hash,
              });
              // window.localStorage.removeItem("JWT_TOKEN");
              this.$store.dispatch("onResetFnBStoreState");
              this.$store.dispatch("ResetCustomizationData");
              window.localStorage.clear();
              this.$cookie.delete("BRHSID");
              this.$router.push({
                path: "pos-fnb-login",
              });
              this.$toasted.show("Your Shift Has Ended.");
            }
          } else {
            let count = 0;
            this.SelectedFnbItemList.map((item) => {
              if (
                item.is_customization_available &&
                item.is_customization_available == "Y" &&
                item.is_customization_compulsory &&
                item.is_customization_compulsory == "Y"
              ) {
                if (
                  item.hasOwnProperty("customizations") &&
                  item.customizations.length == 0
                ) {
                  count++;
                  this.$toasted.show(
                    "Please add customization for " + item.item_name
                  );
                  return;
                }
              }
            });
            if (count == 0) {
              this.onSwtichModule({ name: "FnBItemsModule" });
              this.GET_PAYMENT_MODES(5);
            }
          }
        });
      },
    },
  };
</script>

<style>
  .pos-fnb-footer {
    height: 100px;
  }

  .pos-fnb-menus {
    bottom: 0;
    width: 100%;
    /* overflow-x: scroll; */
    height: 100px;
    display: block;
    position: relative;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: var(--posFnbGlobalRadius);
    background-color: #fff;
    border: 3px solid #007bff;
  }

  .pos-fnb-navigation {
    left: 0;
    bottom: 0;
    height: 100px;
    width: 100%;
    overflow: hidden;
  }

  .pos-fnb-navigation .btn-grey-lg,
  .pos-fnb-navigation .btn-blue-lg,
  .pos-fnb-navigation .btn-white-lg {
    height: 45px;
  }

  .Fnb-hidden-menus {
    left: 0;
    width: calc(100% + 2px);
    top: -182px;
    height: 182px;
    overflow: hidden;
    padding-left: 15px;
    position: absolute;
    padding-right: 15px;
    background-color: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom: 0.5px solid #007bff;
    border-top: 3px solid #007bff;
    border-left: 3px solid #007bff;
    border-right: 3px solid #007bff;
    z-index: 11;
  }
</style>

<style scoped>
  .Fnb-hidden-menus {
    left: 0;
    width: calc(100% + 2px);
    top: -105px;
    height: 100px;
    overflow-x: scroll;
    padding-left: 15px;
    position: absolute;
    padding-right: 15px;
    background-color: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom: 0.5px solid #007bff;
    border-top: 3px solid #007bff;
    border-left: 3px solid #007bff;
    border-right: 3px solid #007bff;
    z-index: 11;
  }
  .category-scroll {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    justify-content: space-between;
    /* scrollbar-width: none; */
  }

  .btnDisable {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posFnbFooter.vue